module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/lexi-ginsburg-fbfc71396a392170bfb780a1b483991b.jpg";